import { Icon } from "components/SvgIcons";
import { useRenderDevice } from "helpers/hooks/useRenderDevice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ImageEditor from "shared/ImgEditor";
import Modal from "shared/Modal";
import { togglePamentModal, modalPayment } from "store/modalReducer";
import { IconWrap } from "./styled";

const ModalEditor = ({ photo, setCropPhoto }) => {
  const isPaymentModal = useSelector(modalPayment);
  const isMobile = useRenderDevice({ max: 768 });
  const dispatch = useDispatch();
  return (
    <>
      {isPaymentModal && photo ? (
        <Modal type={isMobile ? "login" : "primary"}>
          <IconWrap onClick={() => dispatch(togglePamentModal(false))}>
            <Icon icon="close_2" />
          </IconWrap>
          <ImageEditor image={photo} setSave={setCropPhoto} closeModal={() => dispatch(togglePamentModal(false))} />
        </Modal>
      ) : null}
    </>
  );
};

export default ModalEditor;
